import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { Brands } from "@shared/utils/brand-utils";
import { environment } from "../../../environments/environment";
import {
  CONDITIONS_GENERALES,
  CONTRACTDETAILS,
  CONTRACTDETAILS_PARTNER_WITHOUT_BRAND,
  CONTRACTDETAILS_PARTNER,
  MENTIONS_LEGALES,
  MON_PROFIL,
  NOUS_CONTACTER,
  PAGE_NON_TROUVEE,
  PAYMENT_REQUEST,
  RECEIPTSDETAIL,
  REGULARISATION_OFF,
  REGULARISATION_ON,
  STORED_DOCUMENTS
} from "../constants/route.constants";

@Injectable({ providedIn: "root" })
export class BrandGuard {
  // Configuration for allowed routes per brand (except VYV)
  private readonly allowedRoutes: Record<string, string[]> = {
    HM: [
      RECEIPTSDETAIL,
      STORED_DOCUMENTS,
      CONTRACTDETAILS,
      CONTRACTDETAILS_PARTNER,
      MENTIONS_LEGALES,
      NOUS_CONTACTER,
      MON_PROFIL,
      CONDITIONS_GENERALES,
      REGULARISATION_OFF,
      PAYMENT_REQUEST,
      REGULARISATION_ON
    ],
    MGEN: [
      RECEIPTSDETAIL,
      STORED_DOCUMENTS,
      CONTRACTDETAILS,
      CONTRACTDETAILS_PARTNER,
      MENTIONS_LEGALES,
      NOUS_CONTACTER,
      MON_PROFIL,
      CONDITIONS_GENERALES,
      REGULARISATION_OFF,
      PAYMENT_REQUEST,
      REGULARISATION_ON
    ],
    MNT: [
      RECEIPTSDETAIL,
      STORED_DOCUMENTS,
      CONTRACTDETAILS,
      CONTRACTDETAILS_PARTNER_WITHOUT_BRAND,
      MENTIONS_LEGALES,
      NOUS_CONTACTER,
      MON_PROFIL,
      CONDITIONS_GENERALES,
      REGULARISATION_OFF,
      PAYMENT_REQUEST,
      REGULARISATION_ON
    ],
  };

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const currentBrand = environment.brand;

    // Allow all routes for VYV brand
    if (currentBrand === Brands.VYV) {
      return true;
    }

    // Get the route path
    const routePath = route.routeConfig?.path || "";

    // Check if the current brand has specific allowed routes
    const allowedForBrand = this.allowedRoutes[currentBrand];

    if (allowedForBrand && allowedForBrand.includes(routePath)) {
      return true;
    }

    // For any other brand or route combination, redirect to 404
    this.router.navigate([PAGE_NON_TROUVEE]);
    return false;
  }
}

export const brandGuard: CanActivateFn = (route, state) => {
  return inject(BrandGuard).canActivate(route);
};
